var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02841 0.920898C4.89698 0.920898 4.77397 0.957575 4.66874 1.02142L0.354277 3.52906C0.135201 3.65639 0 3.89336 0 4.15V14.2057C0 14.4607 0.133424 14.6963 0.350208 14.8243C0.566991 14.9522 0.834353 14.9532 1.05197 14.8267L5.05054 12.5026L9.64494 14.8392C9.73452 14.8871 9.83549 14.9159 9.94264 14.9203C9.96096 14.9211 9.9793 14.9211 9.99761 14.9204C10.1191 14.9159 10.2327 14.8801 10.3308 14.8206L14.6457 12.3127C14.8648 12.1854 15 11.9484 15 11.6918V1.63607C15 1.38113 14.8666 1.14547 14.6498 1.01751C14.433 0.889551 14.1656 0.888643 13.948 1.01513L9.94946 3.33916L5.35543 1.0028C5.25936 0.951367 5.15017 0.92189 5.03429 0.920923L5.02841 0.920898ZM10.6747 12.9734L13.5938 11.2768V2.86844L10.6747 4.56503V12.9734ZM9.26847 4.592L5.73153 2.79324V11.2498L9.26847 13.0486V4.592ZM1.40625 4.56503L4.32528 2.86844V11.2768L1.40625 12.9734V4.56503Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/iconMap.6f384169.svg";
export { ForwardRef as ReactComponent };